import React from 'react';

const DifferentStartDate = () => {
  return <div className="dbi-compare-mobile-active"></div>;
};

export default DifferentStartDate;
